module.exports = __webpack_public_path__ + "static/media/22-speaker_profile.4d1d389e.webp";